var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8"},[_c('ImportTable',{attrs:{"items":_vm.historic_imports},on:{"on_import_selected":_vm.on_import_selected,"on_import_deleted":_vm.on_import_deleted}}),(_vm.import_record)?_c('ImportEditor',{attrs:{"disabled":true,"show_tab":_vm.editor_show_tab,"import_record":_vm.import_record,"variant":_vm.variant}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }